import React from 'react'
import { AphroditeIframe } from '@ui'
import { accessToken } from '@stores/apollo'
import Appbar from '../Appbar'

export default function MoveOrders() {
  const url = '/ap/Current/orders'

  return (
    <>
      <Appbar title="Move Orders" />
      <AphroditeIframe token={accessToken} path={url} />
    </>
  )
}
